import React, {useEffect, useState} from "react";
import {OutlayInterface, OutlayItemInterface} from "../../../../service/Business/Interfaces/OutlayInterface";
import InputDateTable from "./InputDateTable";
import InputFileTable from "./InputFileTable";
import "../FormAtelier.scss";
import formatEuro from "../../../../utils/formatEuro";

type TableOutlayItemProps = {
    dataItemOutlay: OutlayItemInterface[];
    dataOutlay: OutlayInterface;
    handlerEvent: (listOutlayItemAdd: OutlayItemInterface[],
                   listOutlayItemDel: OutlayItemInterface[],
                   listOutlayItemModify: OutlayItemInterface[]) => void;
};

const TableOutlayItem: React.FunctionComponent<TableOutlayItemProps> = (props) => {

    const [listOutlayItemTable, setListOutlayItemTable] = useState<OutlayItemInterface[]>(props.dataItemOutlay);
    const [listOutlayItemAdd, setListOutlayItemAdd] = useState<OutlayItemInterface[]>([]);
    const [listOutlayItemDel, setListOutlayItemDel] = useState<OutlayItemInterface[]>([]);
    const [listOutlayItemModify, setListOutlayItemModify] = useState<OutlayItemInterface[]>([]);

    const [currentLabel, setCurrentLabel] = useState<string>("");
    const [currentPrice, setCurrentPrice] = useState<string>("");
    const [currentDate, setCurrentDate] = useState<Date>(new Date());
    const [file, setFile] = useState<File>();

    const [editingRowId, setEditingRowId] = useState<number | null>(null);
    const [cptAdd, setCptAdd] = useState<number>(-1);

    useEffect(() => {
        let listTmp: OutlayItemInterface[] = [...props.dataItemOutlay, ...listOutlayItemAdd];
        for (const del of listOutlayItemDel) {
            listTmp = listTmp.filter((row) => row.id !== del.id);
        }
        for (const mod of listOutlayItemModify) {
            listTmp = listTmp.map((row) => row.id === mod.id ? {...row, ...mod} : row);
        }
        setListOutlayItemTable(listTmp);
        props.handlerEvent(listOutlayItemAdd, listOutlayItemDel, listOutlayItemModify);
    }, [listOutlayItemAdd, listOutlayItemDel, listOutlayItemModify]);

    const addOutlayItem = () => {
        const id = cptAdd;
        const newItem: OutlayItemInterface = {
            id, price: 0, label: "Nouveau frais",
            date: new Date().toDateString(), file: undefined,
            receiptLoaded: false, nameFile: ""
        };
        setListOutlayItemAdd((prev) => [...prev, newItem]);
        setCptAdd((prev) => prev - 1);
        setEditingRowId(id);
        setCurrentLabel(newItem.label);
        setCurrentPrice("0");
        setCurrentDate(new Date());
        setFile(undefined);
    };

    const delOutlayItem = (item: OutlayItemInterface) => {
        if (item.id <= -1) {
            setListOutlayItemAdd((prev) => prev.filter((row) => row.id !== item.id));
        } else {
            setListOutlayItemDel((prev) => [...prev, item]);
        }
        if (editingRowId === item.id) setEditingRowId(null);
    };

    const handleSaveRow = (id: number, price: number, label: string, date: Date, f: File | undefined) => {
        const updated = (row: OutlayItemInterface): OutlayItemInterface =>
            ({...row, price, label, date: date.toDateString(), file: f});

        const onAdd = listOutlayItemAdd.find((o) => o.id === id);
        const onMod = listOutlayItemModify.find((o) => o.id === id);

        if (onAdd) {
            setListOutlayItemAdd((prev) => prev.map((row) => row.id === id ? updated(row) : row));
        } else if (onMod) {
            setListOutlayItemModify((prev) => prev.map((row) => row.id === id ? updated(row) : row));
        } else {
            listOutlayItemTable.forEach((row) => {
                if (row.id === id) setListOutlayItemModify((prev) => [...prev, updated(row)]);
            });
        }
    };

    return (
        <div className="ctcWrapper">
            <div style={{display: "flex", justifyContent: "flex-end"}}>
                <button type="button" className="ctcAddBtn" onClick={addOutlayItem}>
                    <span className="material-symbols-outlined">add</span>
                    Ajouter un frais
                </button>
            </div>

            <div className="ctcTableWrapper">
                <table className="ctcTable">
                    <thead>
                    <tr>
                        <th>Description</th>
                        <th>Date</th>
                        <th>Prix TTC</th>
                        <th>Justificatif</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {listOutlayItemTable.length === 0 && (
                        <tr>
                            <td colSpan={5} className="ctcEmptyRow">
                                Aucun frais — cliquez sur « Ajouter un frais »
                            </td>
                        </tr>
                    )}
                    {listOutlayItemTable.map((e: OutlayItemInterface, index: React.Key) => (
                        <tr key={index} className={editingRowId === e.id ? "ctcRowEditing" : ""}>
                            <td>
                                {editingRowId === e.id
                                    ? <input className="ctcInput" type="text" value={currentLabel}
                                             onChange={(ev) => {
                                                 setCurrentLabel(ev.target.value);
                                                 handleSaveRow(e.id, e.price, ev.target.value, new Date(e.date), file);
                                             }}/>
                                    : <span className="ctcCellName">{e.label}</span>
                                }
                            </td>
                            <td>
                                <InputDateTable
                                    edit={editingRowId === e.id}
                                    value={editingRowId === e.id ? currentDate.toDateString() : e.date}
                                    onChangeHandler={(value) => {
                                        if (value) {
                                            setCurrentDate(value);
                                            handleSaveRow(e.id, e.price, e.label, value, file);
                                        }
                                    }}
                                />
                            </td>
                            <td>
                                {editingRowId === e.id
                                    ? <input className="ctcInput" type="text" style={{width: 90}}
                                             value={currentPrice}
                                             onChange={(ev) => {
                                                 const v = ev.target.value.replaceAll(',', '.');
                                                 const n = parseFloat(v);
                                                 setCurrentPrice(v);
                                                 if (!isNaN(n)) handleSaveRow(e.id, n, e.label, new Date(e.date), file);
                                             }}/>
                                    : <span className="ctcCellPhone">{formatEuro(Number(e.price))}</span>
                                }
                            </td>
                            <td>
                                <InputFileTable
                                    edit={editingRowId === e.id}
                                    nameOutlay={props.dataOutlay.label}
                                    outlayItem={e}
                                    onChangeHandler={(ev) => {
                                        if (ev.target.files) {
                                            const f = ev.target.files[0];
                                            setFile(f);
                                            handleSaveRow(e.id, e.price, e.label, new Date(e.date), f);
                                        }
                                    }}
                                />
                            </td>
                            <td>
                                <div className="ctcActions">
                                    {editingRowId === e.id
                                        ? <button type="button" className="ctcBtn ctcBtnConfirm" title="Valider"
                                                  onClick={() => setEditingRowId(null)}>
                                            <span className="material-symbols-outlined">check</span>
                                          </button>
                                        : <button type="button" className="ctcBtn ctcBtnEdit" title="Modifier"
                                                  onClick={() => {
                                                      setCurrentLabel(e.label);
                                                      setCurrentPrice(e.price.toString().replaceAll(',', '.'));
                                                      setCurrentDate(new Date(e.date));
                                                      setFile(undefined);
                                                      setEditingRowId(e.id);
                                                  }}>
                                            <span className="material-symbols-outlined">edit</span>
                                          </button>
                                    }
                                    <button type="button" className="ctcBtn ctcBtnDelete" title="Supprimer"
                                            onClick={() => delOutlayItem(e)}>
                                        <span className="material-symbols-outlined">delete</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TableOutlayItem;
